import { ProfileType, RecommendationStatus, ResultKey, ScopeResult } from '../types';

export const MAIL_REGEX = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;

// Check if input as at least one character and not only spaces
export const INPUT_REGEX = /^(?=.*\S).+$/;

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const QUARTER = [
  { key: 'Q1', value: ['January', 'February', 'March'] },
  { key: 'Q2', value: ['April', 'May', 'June'] },
  { key: 'Q3', value: ['July', 'August', 'September'] },
  { key: 'Q4', value: ['October', 'November', 'December'] },
];

export const RESULT_TYPES = [
  { key: 'rule', name: 'Rule' },
  { key: 'presence', name: 'Presence' },
  { key: 'value', name: 'Value' },
  { key: 'percentage', name: 'Percentage' },
];

export const RECOMMENDATION_DISPLAY = [
  { key: 'all', name: 'All' },
  { key: 'only-recommendations', name: 'Only recommendations' },
];

export const SEARCH_MODE = [
  { key: '<', name: 'Below' },
  { key: '>', name: 'Higher' },
  { key: '=', name: 'Equal' },
];

export const CRITICITY_VALUE = [
  { key: 'low', name: 'Low' },
  { key: 'medium', name: 'Medium' },
  { key: 'high', name: 'High' },
  { key: 'very-high', name: 'Very high' },
];

export const RULE_VALUE = [
  { key: 'good', name: 'Good' },
  { key: 'medium', name: 'Medium' },
  { key: 'bad', name: 'To improve' },
  { key: 'n/d', name: 'No data' },
  { key: 'n/a', name: 'Not applicable' },
];

export const PRESENCE_VALUE = [
  { key: '1', name: 'Used' },
  { key: '0.5', name: 'Partially used' },
  { key: '0', name: 'Not used' },
];

export const OBSOLESCENCE_VALUE = [
  {
    key: 'distribution',
    name: 'Scoring distribution',
    children: [
      { key: '0', label: '0' },
      { key: '1', label: '1' },
      { key: '2', label: '2' },
      { key: '3', label: '3' },
      { key: '4', label: '4' },
      { key: '5', label: '5' },
      { key: '6', label: '6' },
      { key: '7', label: '7' },
      { key: '8', label: '8' },
      { key: '9', label: '9' },
      { key: '10', label: '10' },
      { key: '11', label: '11' },
      { key: '12', label: '12' },
      { key: '13', label: '13' },
      { key: '14', label: '14' },
      { key: '15', label: '15' },
      { key: 'n/d', label: 'No data' },
    ],
  },
  {
    key: 'distribution-percentage',
    name: 'Obsolete assets percentage distribution',
    children: [
      { key: '0-9', label: '0-9%' },
      { key: '10-19', label: '10-19%' },
      { key: '20-29', label: '20-29%' },
      { key: '30-39', label: '30-39%' },
      { key: '40-49', label: '40-49%' },
      { key: '50-59', label: '50-59%' },
      { key: '60-69', label: '60-69%' },
      { key: '70-79', label: '70-79%' },
      { key: '80-89', label: '80-89%' },
      { key: '90-100', label: '90-100%' },
      { key: 'n/d', label: 'No data' },
    ],
  },
  {
    key: 'category',
    name: 'Category',
    children: [
      { key: 'OS', label: 'OS' },
      { key: 'Hosting', label: 'Hosting' },
      { key: 'Middleware', label: 'Middleware' },
      { key: 'Database', label: 'Database' },
      { key: 'Language', label: 'Language' },
    ],
  },
];

export const DISTRIBUTION_OBSOLESCENCE_VALUE = [
  { key: '0', name: '0' },
  { key: '1', name: '1' },
  { key: '2', name: '2' },
];

export const TIME_INTERVAL = [
  { key: 'LAST_YEAR', name: 'Last year' },
  { key: 'LAST_MONTH', name: 'Last month' },
];

export const SORTING_TYPE = ['GBSU Cost', 'Vendor', 'Infrastructure'];

export const PROFILE_TYPE: ProfileType[] = ['Application manager', 'RC/Tribe manager', 'CIO', 'Architect', 'Other'];

export const GLOBAL_TOTAL_RESULT_KEYS: readonly ResultKey[] = [
  'cost',
  'cost-forecast',
  'cost-prev-year',
  'tco_infrastructure-cost_gts',
  'tco_infrastructure-cost_gts-forecast',
  'tco_infrastructure-cost_gts-prev-year',
  'tco_infrastructure-cost_azure',
  'tco_infrastructure-cost_azure-forecast',
  'tco_gbsu-cost_non-workforce',
  'tco_gbsu-cost_non-workforce-forecast',
  'tco_gbsu-cost_non-workforce-prev-year',
  'tco_gbsu-cost_workforce',
  'tco_gbsu-cost_workforce-forecast',
  'tco_gbsu-cost_workforce-prev-year',
  'tco_vendor-cost_software',
  'tco_vendor-cost_software-forecast',
  'tco_vendor-cost_software-prev-year',
];

export const SELECTED_CHASING_LIMIT = [
  { label: '6 chasings', value: 6 },
  { label: '10 chasings', value: 10 },
];

export const OBSOLESCENCE_COMPONENT_LIMIT = [
  { label: '10 versions', value: 10 },
  { label: '20 versions', value: 20 },
  { label: '40 versions', value: 40 },
  { label: '60 versions', value: 60 },
  { label: '80 versions', value: 80 },
  { label: '100 versions', value: 100 },
];

export const THIRDPARTY_SOFTWARE_LIMIT = [
  { label: '20 softwares', value: 20 },
  { label: '40 softwares', value: 40 },
  { label: '60 softwares', value: 60 },
];

export const OBSOLESCENCE_RECOMMENDATIONS_LIMIT = [
  { label: '10 recommendations', value: 10 },
  { label: '20 recommendations', value: 20 },
  { label: '40 recommendations', value: 40 },
  { label: '60 recommendations', value: 60 },
  { label: '80 recommendations', value: 80 },
  { label: '100 recommendations', value: 100 },
];

/**
 * Constant for Obsolescence V3 and score
 */
const OBSOLESCENCE_COMPONENT_TYPES = ['Database', 'Middleware', 'OS', 'Infrastructure', 'Software'] as const;
const MAX_EOL_SCORE = 3;
export const OBSOLESCENCE_V3_SCORE = OBSOLESCENCE_COMPONENT_TYPES.length * MAX_EOL_SCORE;

/**
 * ResultKeys displayed in the home page and application details page
 */
export const HOME_RESULT_KEYS: ResultKey[] = [
  'cost-forecast',
  'tbs',
  'finops',
  'health',
  'health-changes',
  'global_taxon_kearid',
  'global_taxon_iappliid',
  'global_taxon_iappliname',
  'sgmarkets',
  'digital-capability-security',
  'digital-capability-ci-cd',
  'digital-capability-web',
  'digital-capability-api',
  'digital-capability-monitoring',
  'obsolescence',
  // 'gbis-standard',
  'global_taxon_nova-compatible',
  'other_transformation-path_transformation-path',
];

export const DETAIL_RESULT_KEYS: ResultKey[] = [
  'cost-forecast',
  'cost',
  'cost-prev-year',
  'tco_gbsu-cost_workforce',
  'tco_gbsu-cost_workforce-forecast',
  'tco_gbsu-cost_workforce-prev-year',
  'tco_gbsu-cost_non-workforce',
  'tco_gbsu-cost_non-workforce-forecast',
  'tco_gbsu-cost_non-workforce-prev-year',
  'tco_vendor-cost_software',
  'tco_vendor-cost_software-forecast',
  'tco_vendor-cost_software-prev-year',
  'tco_infrastructure-cost_azure',
  'tco_infrastructure-cost_azure-forecast',
  'tco_infrastructure-cost_gts',
  'tco_infrastructure-cost_gts-forecast',
  'tco_infrastructure-cost_gts-prev-year',
  'global_taxon_iappliname',
  'global_taxon_iappliid',
  'global_taxon_kearid',
  'tbs',
  'finops',
  'tco_finops_orchestrated-container',
  'health',
  'health-changes',
  'sgmarkets',
  'digital-capability-security',
  'digital-capability-ci-cd',
  'digital-capability-web',
  'digital-capability-api',
  'digital-capability-monitoring',
  'obsolescence',
  // 'gbis-standard',
  'global_taxon_application-manager-email',
  'global_taxon_application-owner-email',
  'global_taxon_application-type',
  'global_taxon_application-manager-email',
  'global_taxon_application-owner-email',
  'global_taxon_architecture-type',
  'global_taxon_irt',
  'global_taxon_bdr',
  'global_taxon_languages',
  'global_taxon_country',
  'global_taxon_criticality',
  'global_taxon_functional-architecture',
  'global_taxon_managed-by',
  'global_taxon_status',
  'global_taxon_tribe',
  'global_taxon_trigram',
  'global_taxon_owned-by',
  'global_taxon_nova-compatible',
  'global_taxon_ownership-rc',
  'global_taxon_management-rc',
  'other_transformation-path_transformation-path',
];

export const HEALTH_COMPONENT = ['KSI', 'Changes'] as const;

export const NOVA_OPTIONS = [
  { key: 'yes', name: 'Yes' },
  { key: 'no', name: 'No' },
] as const;

export const CERTIFICATIONS_OPTIONS = [
  { key: 'Certified', name: 'Certified' },
  { key: 'Error', name: 'Error' },
  { key: 'Not certified', name: 'Not certified' },
];

export const RULES_WEIGHT: readonly (ScopeResult | undefined | null)[] = [
  'bad',
  'medium',
  'good',
  'intermediate',
  'n/a',
  'n/d',
  undefined,
  null,
] as const;

export const RESULT_LEVEL = [
  { key: 'scope', name: 'Scope' },
  { key: 'component', name: 'Component' },
];

export const OBSOLESCENCE_TOGGLE = [
  { key: 'assets', name: 'No. of assets' },
  { key: 'score', name: 'Score' },
];

export const RECOMMENDATION_TOGGLE = [
  { key: 'application', name: 'Applications' },
  { key: 'all', name: 'All' },
];
